import Paginator from "components/Blocks/Paginator/Paginator";

export default Paginator;
